/* eslint-disable @typescript-eslint/no-explicit-any */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import cx from "classnames";
import { Link } from "react-router-dom";
import { useIsMobile } from "src/hooks/viewport/useViewportCategory";
import { LinkTo } from "../../../../globalTypes";
import { disabledCss } from "./styles";
import { VOID_NAVIGATION_CALLBACK } from "../../../../utils/internalLinksParsing";

type Props = {
  value: string;
  linkTo: LinkTo<any>;
  className?: string;
  disabled?: boolean;
};

const FlowioLinkToDetail: FC<Props> = ({
  value,
  linkTo,
  disabled,
  className,
}) => {
  const isMobile = useIsMobile();

  return (
    <Link
      to={!disabled ? linkTo : VOID_NAVIGATION_CALLBACK}
      className={cx("ewainput-link", className)}
      css={disabled && disabledCss}
      target={isMobile ? "_self" : "_blank"}
      rel="noopener noreferrer"
    >
      {value}
    </Link>
  );
};

export default FlowioLinkToDetail;
export type FlowioLinkToDetailProps = Props;
